// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import {remoteForm} from '@github/remote-form'

function updateChoices() {
  for (const selected of document.querySelectorAll('.js-newsletter-frequency-choice.selected')) {
    selected.classList.remove('selected')
  }
  const checked = document.querySelector<HTMLElement>('.js-newsletter-frequency-radio:enabled:checked')!
  const choice = checked.closest<HTMLElement>('.js-newsletter-frequency-choice')!
  choice.classList.add('selected')
}

observe('.js-subscription-toggle', function () {
  updateChoices()
})

on('change', '.js-newsletter-frequency-radio', function () {
  updateChoices()
})

remoteForm('.js-subscription-toggle', async function (form, wants) {
  await wants.text()

  const notice = form.querySelector<HTMLElement>('.selected .notice')!
  notice.classList.add('visible')
  setTimeout(function () {
    notice.classList.remove('visible')
  }, 2000)
})
